import React, { createContext } from 'react';
import useEngagementPortals from './useEngagementPortals';

interface EngagementPortalsContextType {
  availableEngagementPortals: EngagementPortal[];
  allEngagementPortals: EngagementPortal[];
  isLoadingEngagementPortals: boolean;
}

export const EngagementPortalsContext =
  createContext<EngagementPortalsContextType>({
    availableEngagementPortals: [],
    allEngagementPortals: [],
    isLoadingEngagementPortals: true,
  });

const EngagementPortalsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { availableEngagementPortals, allEngagementPortals, isLoading } =
    useEngagementPortals();

  return (
    <EngagementPortalsContext.Provider
      value={{
        availableEngagementPortals,
        allEngagementPortals,
        isLoadingEngagementPortals: isLoading,
      }}
    >
      {children}
    </EngagementPortalsContext.Provider>
  );
};

export default EngagementPortalsProvider;
